import useLocale from './useLocale'

const useDoesIncludeLocale = (locales: string[]) => {
  const { locale } = useLocale()
  return locales.includes(locale)
}

export default useDoesIncludeLocale
